// extracted by mini-css-extract-plugin
export var black = "_z-6";
export var brand = "_z-1";
export var ddefault = "_z-0";
export var error = "_z-3";
export var gray = "_z-2";
export var highContrast = "_z-8";
export var outline = "_z-7";
export var success = "_z-5";
export var warning = "_z-4";